import { Check } from "lucide-react";
import { bottleSummary } from "@/components/BottleDetailsDialog";

export const BottleChips = ({ bottles, onEdit, selected = [], onToggle, max = 40 }) => (
  <div className="flex flex-wrap gap-1.5 mt-2" data-testid="bottle-chips">
    {bottles.slice(0, max).map((b) => {
      const on = selected.includes(b.barcode);
      return (
        <button key={b.id} type="button" title={`${bottleSummary(b) || "No purchase details yet"}\nClick to select · double-click to open`}
          onClick={(e) => { e.stopPropagation(); onToggle ? onToggle(b) : onEdit(b); }}
          onDoubleClick={(e) => { e.stopPropagation(); onEdit(b); }}
          className={`select-none font-mono text-xs rounded border px-2 py-1 transition-colors ${on ? "bg-[#D4AF37] border-[#D4AF37] text-[#0D0A0B]" : "bg-[#0D0A0B] border-[#2E252A] text-[#F5F0EB] hover:border-[#D4AF37]"}`}
          aria-pressed={on} data-testid={`bottle-chip-${b.barcode}`}>
          {on && <Check className="w-3 h-3 inline mr-1" />}
          {b.barcode}{b.box_number && <span className={on ? "text-[#0D0A0B]/70" : "text-[#6E665D]"}> · box {b.box_number}</span>}
        </button>
      );
    })}
    {bottles.length > max && <span className="text-xs text-[#6E665D] self-center">+{bottles.length - max} more</span>}
  </div>
);
